import { motion } from 'motion/react';
import { FunctionComponent } from 'react';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { useAppDispatch } from '../../store/Hooks';
import { Team } from '../../types/GameplayTypes';
import { adaptTransition, AsyncAnimationProps, directed } from '../../util/Animation';
import { GameBoardZIndex } from './GameBoardZIndex';
import BuzzerSvg from '/assets/images/Buzzer.svg';

type Props = AsyncAnimationProps & {
	team: Team;
};

export const Buzzer: FunctionComponent<Props> = (props) => {
	const dispatch = useAppDispatch();
	const controllingTeam = useGameplaySelector(gamePlayStore.selectors.controllingTeam);
	const questionVisible = useGameplaySelector(gamePlayStore.selectors.questionVisible);

	const isA = props.team === Team.A;
	const bottom = directed({ from: -500, to: -50 }, props);

	function onClick() {
		dispatch(gamePlayStore.actions.faceOffBuzz({ team: props.team }));
	}

	function teamFocusStyles() {
		if (props.team === controllingTeam) {
			return { filter: 'brightness(1.3)' };
		} else if ((controllingTeam === undefined) && questionVisible) {
			return { filter: 'brightness(1.0)' };
		} else {
			return { filter: 'brightness(0.3)' };
		}
	}

	return <motion.div
		initial={{ bottom: bottom.from }}
		animate={{ bottom: bottom.to, ...teamFocusStyles() }}
		transition={adaptTransition({
			duration: 0.6, delay: props.reverse ? 0 : 0.6,
			type: 'spring', bounce: .5,
		})}
		style={{
			position: 'fixed',
			[isA ? 'left' : 'right']: '20%',
			height: '25vh',
			zIndex: GameBoardZIndex.Overlay,
		}}
	>
		<BuzzerSvg
			aria-label={`Buzzer for ${isA ? 'blue team' : 'red team'}`}
			cursor='pointer'
			onClick={onClick} style={{
				height: '100%',
				// Hue shift from the red used in the image to the Team A blue
				...isA && { filter: 'hue-rotate(184deg)' },
			}} />
	</motion.div>;
};
